import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { DxDropDownBoxComponent } from 'devextreme-angular';
import { bookIcon, warningIcon } from 'src/app/app-icons';
import { StandardTrainingCategoryViewModel } from 'src/app/models/standard-training-category/standard-training-category-view.model';

@Component({
  selector: 'app-standard-catalogue-selector',
  standalone: false,
  templateUrl: './standard-catalogue-selector.component.html',
  styleUrl: './standard-catalogue-selector.component.scss',
})
export class StandardCatalogueSelectorComponent {
  @ViewChild('standardCategoryDropDown', { static: false })
  standardCategoryDropDown!: DxDropDownBoxComponent;

  @Input() isViewMode = false;
  @Input() showTitle = true;

  @Input()
  standardTrainingCategories: StandardTrainingCategoryViewModel[] = [];

  @Input()
  usedStandardTrainingCategories: StandardTrainingCategoryViewModel[] = [];

  @Input() standardTrainingCategoryIds: string[] = [];
  @Output() standardTrainingCategoryIdsChange = new EventEmitter<string[]>();
    
  showStandardCategoryModal = false;

  constructor(
    private translateService: TranslateService,
    private sanitizer: DomSanitizer
  ) {}

  openStandardCategoryModal(): void {
    this.standardCategoryDropDown.instance.close();
    this.showStandardCategoryModal = true;
  }

  clearStandardCategory(e: any): void {
    if (e.value) {
      return;
    }

    this.standardTrainingCategoryIds = [];
    this.standardTrainingCategoryIdsChange.emit(
      this.standardTrainingCategoryIds
    );
  }

  onStandardCategoriesSelected(
    categories: StandardTrainingCategoryViewModel[]
  ): void {
    this.standardTrainingCategoryIds = categories.map(c => c.id);

    this.standardTrainingCategoryIdsChange.emit(
      this.standardTrainingCategoryIds
    );
  }

  getStandardTrainingCatalogueText(): string {
    const categories = this.standardTrainingCategories
      .filter(x => this.standardTrainingCategoryIds.includes(x.id))
      .map(x => x.name);

    return this.translateService.instant(
      'STANDARD-CATALOGUE.SHARED-WITH-SUBSCRIBERS-UNDER',
      {
        standardCategories: categories.join(', ')
      }
    );
  }

  getBookIcon() {
    return this.sanitizer.bypassSecurityTrustHtml(bookIcon);
  }

  getWarningIcon() {
    return this.sanitizer.bypassSecurityTrustHtml(warningIcon);
  }
}
